import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import Index from "../../components/about/index";
import Devis from "../../components/Devis";


const heroContent = {
  heroImage: "img/hero/dark.jpg",
  heroMobileImage: "img-mobile",
  heroTitleName: "je suis Amazigh BOUGHAREB.",
  heroDesignation: "Développeur Web Full Stack",
  heroDescriptions: `Professionnel web indépendant avec compétences en développement, design et gestion de projets. Passionné par l'expérience utilisateur et la création de solutions web innovantes.`,
  heroBtn: "À propos de moi",
};

const Hero = () => {
  const [isModalOneOpen, setIsModalOneOpen] = useState(false);
  const [isModalTwoOpen, setIsModalTwoOpen] = useState(false);

  useEffect(() => {
    const animateLetters = () => {
      const titleLetters = document.querySelectorAll(".hero-title-letter");
      const designationLetters = document.querySelectorAll(".hero-designation-letter");

      titleLetters.forEach((letter, index) => {
        letter.style.animation = `fade-in 6s ${index * 0.1}s infinite`;
      });

      designationLetters.forEach((letter, index) => {
        letter.style.animation = `fade-in 6s ${(index + titleLetters.length) * 0.1}s infinite`;
      });
    };

    animateLetters();

    return () => {
      const letters = document.querySelectorAll(".hero-title-letter, .hero-designation-letter");

      letters.forEach((letter) => {
        letter.style.animation = "";
      });
    };
  }, []);

  function toggleModalOne() {
    setIsModalOneOpen(!isModalOneOpen);
  }

  function toggleModalTwo() {
    setIsModalTwoOpen(!isModalTwoOpen);
  }

  return (
    <>
      <div className="row home-details-container align-items-center">
        <div
          className="col-lg-4 bg position-fixed d-none d-lg-block"
          style={{
            backgroundImage: `url(${
              process.env.PUBLIC_URL + heroContent.heroImage
            })`,
          }}
        ></div>
        <div className="col-12 col-lg-8 offset-lg-4 home-details  text-center text-lg-start">
          <div>
            <img
              src={`img/hero/${heroContent.heroMobileImage}.jpg`}
              className="img-fluid main-img-mobile d-sm-block d-lg-none"
              alt="hero man"
            />
            
            <h1 className="text-uppercase poppins-font">
              <span style={{ color: "#ffb400" }}>
                {heroContent.heroTitleName.split(" ").map((word, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && " "}
                    {word.split("").map((letter, letterIndex) => (
                      <span
                        key={`${index}-${letterIndex}`}
                        className="hero-title-letter"
                        style={{ animationDelay: `${(index * 6 + letterIndex) * 0.1}s` }}
                      >
                        {letter}
                      </span>
                    ))}
                  </React.Fragment>
                ))}
              </span>
              <div class="triangle">
              </div>
              <span>
                {heroContent.heroDesignation.split(" ").map((word, index) => (
                  <React.Fragment key={index}>
                    {index > 0 && " "}
                    {word.split("").map((letter, letterIndex) => (
                      <span
                        key={`${index}-${letterIndex}`}
                        className="hero-designation-letter"
                        style={{ animationDelay: `${((index + heroContent.heroTitleName.split(" ").length) * 6 + letterIndex) * 0.1}s` }}
                      >
                        {letter}
                      </span>
                    ))}
                  </React.Fragment>
                ))}
              </span>
            </h1>
            <p className="open-sans-font">
              <i>{heroContent.heroDescriptions}</i>
            </p>
            <button className="button" onClick={toggleModalOne}>
              <span className="button-text">{heroContent.heroBtn}</span>
              <span className="button-icon fa fa-arrow-right"></span>
            </button>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            {/* <button className="button" onClick={toggleModalTwo}>
              <span className="button-text">Demande de devis</span>
              <span className="button-icon fa fa-calculator"></span>
            </button> */}
          </div>
        </div>
      </div>

      <Modal
        isOpen={isModalOneOpen}
        onRequestClose={toggleModalOne}
        contentLabel="My dialog"
        className="custom-modal dark hero"
        overlayClassName="custom-overlay dark"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalOne}>
            <img src="/img/cancel.svg" alt="close icon" />
          </button>
          <div className="box_inner about">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  À PROPOS <span>DE MOI</span>
                </h1>
                <span className="title-bg">Cv</span>
              </div>
              <Index />
            </div>
          </div>
        </div>   

      </Modal>
      <Modal
        isOpen={isModalTwoOpen}
        onRequestClose={toggleModalTwo}
        contentLabel="My dialog2"
        className="custom-modal dark hero"
        overlayClassName="custom-overlay dark"
        closeTimeoutMS={500}
      >
        <div>
          <button className="close-modal" onClick={toggleModalTwo}>
            <img src="/img/cancel.svg" alt="close icon" />
          </button>
          <div className="box_inner devis">
            <div data-aos="fade-up" data-aos-duration="1200">
              <div className="title-section text-left text-sm-center">
                <h1>
                  Demande <span>de devis</span>
                </h1>
                <span className="title-bg">Devis</span>
              </div>
              <Devis />
            </div>
          </div>
        </div>   

      </Modal>
    </>
  );
};

export default Hero;
